module.exports = __webpack_public_path__ + "img/pic_2.92d40d89.png";